// extracted by mini-css-extract-plugin
export var carrierIcon = "_y9-0";
export var carrierLogo = "_y9-1";
export var detailsSection = "_y9-2";